import Furniture from './Furniture';
import Heart from 'app/campout/Heart';

const STATE_SHADOW = 1;
const STATE_APPEAR = 2;
const STATE_SUN = 3;
const STATE_LEAVE = 4;

const ROCK_STATE_LEFT = 1;
const ROCK_STATE_RIGHT = 2;

export default class LizardRock extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.state = STATE_SHADOW;
    this.rockState = ROCK_STATE_RIGHT;
    this.isDay = true;

    this.objects = []; // objects placed on top of the rock

    //
    this.asset.setMixByName('1_shadow', '2_appear', 0.2);
    this.asset.setMixByName('3_sun', '4_leave', 0.2);
    this.asset.setMixByName('2_appear', '4_leave', 0.2);
    this.asset.setMixByName('4_leave', '2_appear', 0.2);
    this.setAnim('1_shadow');

    //
    if (this.data.rock_x) {
      this.asset.x = this.button.x = this.data.rock_x;
      if (this.asset.x < -30) {
        this.rockState = ROCK_STATE_LEFT;
      } else {
        this.rockState = ROCK_STATE_RIGHT;
      }
    }
  }

  createAsset() {
    this.back = this.game.make.image(-22, -34, 'lizard_rock', 'dragback');
    this.back.anchor.set(0.5, 1);
    this.asset = this.game.make.spine(58, -46, 'spine_lizard_rock', true);
    this.asset.anchor.set(0.5, 1);
    this.light = this.game.make.image(-70, -33, 'lizard_rock', 'rays');
    this.light.anchor.set(0.5, 1);
    this.front = this.game.make.image(0, 0, 'lizard_rock', 'grass');
    this.front.anchor.set(0.5, 1);

    this.addChild(this.back);
    this.addChild(this.asset);
    this.addChild(this.light);
    this.addChild(this.front);

    // get root bone
    this.rootBone = this.asset.skeleton.getRootBone();
    // this.scaleDefault = this.rootBone.scaleX;
  }

  updateBounds() {
    this.bb = this.button.getBounds();
    // this.bb.width = 100;
    // this.bb.height = 120;
  }

  // functions for moving furnitures like rock or log
  addObject(obj) {
    if (this.objects.indexOf(obj) === -1) {
      this.objects.push(obj);
    }
  }

  removeObject(obj) {
    const ind = this.objects.indexOf(obj);
    this.objects.splice(ind, 1);
  }

  //
  getTop(bb) {
    const bb1 = new Phaser.Rectangle();
    const bb2 = this.button.getBounds(); // rock bounds
    const top = this.data.top[0];
    bb1.x = bb2.x + top.x;
    bb1.y = bb2.y + top.y;
    bb1.width = top.w;
    bb1.height = top.h;
    if (Phaser.Rectangle.intersects(bb, bb1)) {
      return { y: bb1.y, h: top.h, character: top.character };
    }
    return null;
  }

  getSide(bb) {
    const bb1 = new Phaser.Rectangle();
    const bb2 = this.button.getBounds(); // rock bounds
    const side = this.data.side[0];
    bb1.x = bb2.x + side.x;
    bb1.y = bb2.y + side.y;
    bb1.width = side.w;
    bb1.height = side.h;
    if (Phaser.Rectangle.intersects(bb, bb1)) {
      return { y: bb1.y, h: side.h };
    }
    return null;
  }

  //
  setDay() {
    this.isDay = true;

    this.game.add.tween(this.light).to({ alpha: 1 }, 500, null, true);
  }

  setNight(instant) {
    this.isDay = false;

    if (instant) {
      this.light.alpha = 0;
    } else {
      this.game.add.tween(this.light).to({ alpha: 0 }, 500, null, true);
    }
  }

  setLight(power) {
    super.setLight(power);
    super.setLight2(power);
  }

  updateTint(tween, value, tweenData) {
    super.updateTint(tween, value, tweenData);

    this.back.tint = this.tintColor;
    this.front.tint = this.tintColor;
  }

  //
  addButton() {
    super.addButton();
    this.button.anchor.set(0.5, 1);
  }

  //
  handleInputDown(target, pointer) {
    target;
    if (this.game.deviceMetric.platform.type === 'desktop') {
      // desktop
      if (this.rockState === ROCK_STATE_LEFT) {
        this.rockState = ROCK_STATE_RIGHT;
        this.prevX = this.asset.x;
        const tween = this.game.add
          .tween(this.asset)
          .to({ x: 58 }, 500, Phaser.Easing.Quadratic.Out, true);
        tween.onUpdateCallback(this.updateMove, this);
        tween.onComplete.add(this.onMoveRight, this);
      } else {
        this.rockState = ROCK_STATE_LEFT;
        this.prevX = this.asset.x;
        const tween = this.game.add
          .tween(this.asset)
          .to({ x: -86 }, 500, Phaser.Easing.Quadratic.Out, true);
        tween.onUpdateCallback(this.updateMove, this);
        tween.onComplete.add(this.onMoveLeft, this);
      }

      this.audio = this.game.sounds.playSFX('item_rock', { spriteID: 'sfx' });
    } else {
      // mobile
      this.startPos = { x: this.button.x, y: this.button.y };
      this.drag = true;

      this.dragDx = this.button.x - (pointer.x - this.location.x - this.x);
      this.pointer = pointer;

      //
      this.audio = this.game.sounds
        .playSFX('item_rock', { spriteID: 'sfx', loop: true })
        .get('item_rock');
      this.audio.volume = 0;
    }
  }

  updateMove() {
    this.button.x = this.asset.x;
    const dx = this.asset.x - this.prevX;
    this.prevX = this.asset.x;

    this.moveObjectsBy(dx);
  }

  onMoveRight() {
    this.game.sounds.stopAudioSprite('item_rock', { spriteID: 'sfx' });
    this.audio = null;
    this.onChange.dispatch();
  }

  onMoveLeft() {
    this.game.sounds.stopAudioSprite('item_rock', { spriteID: 'sfx' });
    this.audio = null;
    this.onChange.dispatch();
  }

  handleInputUp() {
    if (this.game.deviceMetric.platform.type !== 'desktop') {
      this.drag = false;
      this.pointer = null;

      //
      this.game.sounds.stopAudioSprite('item_rock', { spriteID: 'sfx' });
      this.audio = null;

      //
      this.onChange.dispatch();
    }
  }

  step(dt) {
    super.step(dt);

    // light
    const power = this.location.lights.getLightAt(
      this.asset.worldPosition.x,
      this.asset.worldPosition.y - (this.asset.height >> 1),
      !this.data.flashlight
    );
    if (power >= 0 && power !== this.lightPower) {
      this.lightPower = power;
      super.setLight(power);
    }

    if (this.drag && this.pointer) {
      // console.log(this.pointer.x, this.pointer.y);
      let x = -this.location.x + this.pointer.x - this.x + this.dragDx;
      x = Phaser.Math.clamp(x, -86, 58);
      const dx = x - this.asset.x;
      this.asset.x = this.button.x = x;
      this.moveObjectsBy(dx);
      //
      this.audio.volume = Math.min(1, Math.abs(dx) / 2);
    } else {
      // x = -36 is light limit
      const border = -30;
      if (this.isDay && this.asset.x < border && this.state === STATE_SHADOW) {
        this.state = STATE_APPEAR;
        this.game.time.events.add(500, this.setAnim, this, '2_appear', false);
        this.game.time.events.add(500, this.playSndLeave, this);
        this.asset.onComplete.add(this.handleAnimAppear, this);
      } else if (
        (this.asset.x > border && this.state === STATE_SUN) ||
        (!this.isDay && this.state !== STATE_LEAVE && this.state !== STATE_SHADOW)
      ) {
        this.state = STATE_LEAVE;
        this.game.time.events.add(500, this.setAnim, this, '4_leave', false);
        this.game.time.events.add(500, this.playSndLeave, this);
        this.asset.onComplete.add(this.handleAnimLeave, this);
      }
    }
  }

  moveObjectsBy(dx) {
    for (let i = 0; i < this.objects.length; i++) {
      const obj = this.objects[i];
      obj.x += dx;
    }
  }

  playSndLeave() {
    this.game.sounds.playSFX('item_lizard', { spriteID: 'sfx' });
  }

  handleAnimAppear() {
    this.asset.onComplete.remove(this.handleAnimAppear, this);
    this.state = STATE_SUN;
    this.setAnim('3_sun');

    if (this.visible) {
      const heart = new Heart(this.game, this.asset.x, -135);
      this.addChild(heart);

      //
      this.location.state.setLoopHint(this.data.hint);
    }
  }

  handleAnimLeave() {
    this.asset.onComplete.remove(this.handleAnimLeave, this);
    this.state = STATE_SHADOW;
    this.setAnim('1_shadow');
  }

  pulse(time = 1500) {
    this.game.add
      .tween(this.rootBone)
      .to({ scaleX: [1.2, 1, 1.2, 1, 1.2, 1], scaleY: [1.2, 1, 1.2, 1, 1.2, 1] }, time, null, true);
  }

  //
  serialize() {
    const data = super.serialize();
    data.rock_x = this.asset.x;
    return data;
  }
}
